document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const navToggle = document.querySelector('.mobile-nav-toggle');
  const nav = document.getElementById('SiteNav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      const open = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-buy-now]').forEach((button) => {
    button.addEventListener('click', async () => {
      const section = button.closest('[data-product-section]');
      if (!section) return;

      const variantField = section.querySelector('[data-variant-select]');
      const quantityField = section.querySelector('[data-buy-now-quantity]');
      const status = section.querySelector('[data-buy-now-status]');
      const variantId = Number(variantField && variantField.value);
      const quantity = Math.max(1, Number(quantityField && quantityField.value) || 1);

      if (!variantId) {
        if (status) status.textContent = 'Please select an available product option.';
        return;
      }

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Opening Checkout…';
      if (status) status.textContent = 'Preparing your order…';

      try {
        // Order Now is a fast-buy flow: start a fresh checkout with only this product.
        const clearResponse = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        });
        if (!clearResponse.ok) throw new Error('Could not prepare your checkout.');

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity }]
          })
        });
        if (!addResponse.ok) throw new Error('Could not add the product to checkout.');

        if (status) status.textContent = 'Redirecting to secure checkout…';
        window.location.href = '/checkout';
      } catch (error) {
        if (status) status.textContent = error.message || 'Something went wrong. Please try again.';
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  });

  // Keep compatibility with any remaining COD forms in older sections.
  document.querySelectorAll('[data-cod-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = form.querySelector('.form-status');
      const submitButton = form.querySelector('button[type="submit"]');
      const data = new FormData(form);
      const variantId = Number(data.get('variant_id'));
      const quantity = Number(data.get('quantity') || 1);
      const name = String(data.get('name') || '').trim();
      const phone = String(data.get('phone') || '').trim();
      const city = String(data.get('city') || '').trim();
      const address = String(data.get('address') || '').trim();
      const notes = String(data.get('notes') || '').trim();
      const productTitle = form.dataset.productTitle || 'Product';

      if (!variantId || !name || !phone || !city || !address) {
        if (status) status.textContent = 'Please complete all required fields.';
        return;
      }

      submitButton.disabled = true;
      if (status) status.textContent = 'Adding your order to checkout…';

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity,
              properties: {
                'COD Customer Name': name,
                'COD Phone': phone,
                'COD City': city,
                'COD Address': address,
                'COD Notes': notes
              }
            }]
          })
        });

        if (!addResponse.ok) throw new Error('Could not add the product to cart.');

        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'COD Requested': 'Yes',
              'Customer Name': name,
              'Customer Phone': phone,
              'Customer City': city
            },
            note: `COD request for ${productTitle}. Address: ${address}${notes ? `. Notes: ${notes}` : ''}`
          })
        });

        if (!updateResponse.ok) throw new Error('Could not prepare the checkout.');
        window.location.href = '/checkout';
      } catch (error) {
        if (status) status.textContent = error.message || 'Something went wrong. Please try again.';
        submitButton.disabled = false;
      }
    });
  });
});
